import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomTranslationPipe } from 'src/app/pipes/custom-translation.pipe';
import { defaultTranslationArray } from 'src/app/pipes/default-translation';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.scss']
})
export class LegalPageComponent implements OnInit {

  isNotFound: boolean = false;
  _language: string = 'en-GB';
  translationData: any;
  content: string = 'CP_LEGAL_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService, 
    private readonly _actRoute: ActivatedRoute, 
    private readonly languageService: LanguageService, private readonly router:Router) { 
    const langId = this._actRoute.snapshot.paramMap.get('languageId');
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
      this.isNotFound = false;
      this._language = langId && this.languageService.checkIsValideLanguage(langId) ? langId : 
      (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
    }
    this._translationService.sharetranslationData.subscribe((data: any) => {
      this.translationData = data;
      this.isTranslationDone = true;
    });
  }

  public isLangIdValid(locale:any): string {
    if(environment.supported_language.includes(locale)){
     return locale
    }else{
     return 'en-GB'
    }
 }

  ngOnInit(): void {
    if(this.router.url.includes('terms-conditions')){
      this.content= 'CP_TERMS_CONDITION_TEMPLATE'
    }else{
      this.content = 'CP_LEGAL_TEMPLATE';
    }
    if (!this.translationData?.length) {
      this._language = this.isLangIdValid(this._language);
      this.getTranslations(this._language);
    }
  }

  /**
   * @description This is done to call translations API in case of reloading screen
   * @param languageId 
   */
  public getTranslations(languageId: string): void {
    this._translationService
      .phraseApiCallForTranslations(languageId)
      .subscribe({
        next: (translations: any[]) => {
          this.translationData = [...this.translationData, ...translations];
          this._translationService.setTranslationData(this.translationData);
          this._translationService.sendSelectedLanguage(this._language);
          this._translationService.sendtranslationValue(this.translationData);
          this.isTranslationDone = true;
          this.checkForTranslatedValues();
        },
        error: (_error: any) => {
          console.error('Error fetching translations:', _error);
          this.isTranslationDone = true;
          this.translationData = defaultTranslationArray;
        }
      });
  }

  public checkForTranslatedValues(): void {
    const langPipe = new CustomTranslationPipe();
    const filteredArr = langPipe.transform(this.content, this.translationData);

    if (Array.isArray(filteredArr) && !filteredArr.length) {
      this._translationService
        .phraseApiCallForTranslations('en-GB')
        .subscribe({
          next: (translations) => {
            this.translationData = [...this.translationData, ...translations];
          },
          error: () => {
            this.isTranslationDone = true;
            this.translationData = defaultTranslationArray;
          }
        });
    }
  }

}
